<template>

<com-item name="game.info" :size="size" :loading="loading" :is-empty="!active" :any-height="true" :no-hover="true">

	<template v-slot:stats>

		<div class="info" v-if="active">

			<div class="info-row" v-if="about.weight">

				<div class="info-label">Weight</div>

				<div class="info-value">{{ about.weight }} / 5</div>

			</div>

			<div class="info-row" v-if="about.rating">

				<div class="info-label">BGG Rating</div>

				<div class="info-value">{{ about.rating }}</div>

			</div>

			<div class="info-group" v-if="artists.length">

				<div class="info-group-label"><plural t="Artist" :n="artists.length" /></div>

				<div class="info-group-values">{{ artists.map(function(d) { return d.name }).join(', ') }}</div>

			</div>

			<div class="info-group" v-if="categories.length">

				<div class="info-group-label"><plural t="Category" :n="categories.length" /></div>

				<div class="info-group-tags">

					<span class="info-tag" v-for="item in categories" :key="item.id">{{ item.name }}</span>

				</div>

			</div>

			<div class="info-group" v-if="mechanics.length">

				<div class="info-group-label"><plural t="Mechanic" :n="mechanics.length" /></div>

				<div class="info-group-tags">

					<span class="info-tag" v-for="item in mechanics" :key="item.id">{{ item.name }}</span>

				</div>

			</div>

			<div class="info-group" v-if="families.length">

				<div class="info-group-label"><plural t="Family" :n="families.length" /></div>

				<div class="info-group-tags">

					<span class="info-tag" v-for="item in families" :key="item.id">{{ item.name }}</span>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			about: {},
			is: { loaded: false }
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		gameData: function() { return this.$store.getters['page/insights/game/game'] },

		active: function() { return this.is.loaded && !this.loading },

		artists: function() { return this.getNames('artists', 'artist') },

		categories: function() { return this.getNames('categories', 'category') },

		mechanics: function() { return this.getNames('mechanics', 'mechanic') },

		families: function() { return this.getNames('families', 'family') }

	},

	watch: {

		gameData: function() { this.fetch() }

	},

	created: function() { this.fetch() },

	methods: {

		fetch: function() {

			if (!this.gameData || !this.gameData.id) return

			var id = this.gameData.id

			if (this.$store.getters['data/games'][id] && this.$store.getters['data/games'][id].description) {

				this.about = this.$store.getters['data/games'][id]
				this.is.loaded = true

			} else {

				this.$store.dispatch('api/games/about', {
					id: id,
					silent: true
				}).then(function() {

					this.about = this.$store.getters['data/games'][id]
					this.is.loaded = true

				}.bind(this))

			}

		},

		getNames: function(data, field) {

			if (!this.about || !this.about[data]) return []

			var names = []

			this.$_.each(this.about[data], function(id) {

				var item = this.$store.getters['data/' + data][id]

				if (item) {

					names.push({
						id: item[field + '_id'],
						name: item[field + '_name']
					})

				}

			}.bind(this))

			return this.$_.sortBy(names, 'name')

		}

	}

}

</script>

<style scoped>

.info {
	width: 100%;
	max-height: 320px;
	overflow-y: auto;
}

.info-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 15px;
}

.info-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.info-label {
	font-size: 13px;
	font-weight: 600;
	color: #333;
}

.info-value {
	font-size: 14px;
	font-weight: 700;
	color: #4881bb;
}

.info-group {
	padding: 8px 15px;
}

.info-group:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.info-group-label {
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-bottom: 4px;
}

.info-group-values {
	font-size: 13px;
	color: #333;
	line-height: 18px;
}

.info-group-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}

.info-tag {
	font-size: 11px;
	font-weight: 500;
	color: #4881bb;
	background-color: rgba(72, 129, 187, 0.1);
	padding: 2px 8px;
	border-radius: 10px;
	line-height: 16px;
}

.is-mobile .info {
	max-height: none;
	overflow-y: visible;
}

</style>
